import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronsLeftIcon = createIcon(
  <React.Fragment>
    <polyline points="11 17 6 12 11 7" />
    <polyline points="18 17 13 12 18 7" />
  </React.Fragment>,
  'ChevronsLeftIcon'
);
